/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

export default class ServicePackageResponse {
  packageNumber: number
  packageName: string
  totalMoop: number
  totalCharge: number
  totalMoopNonPlus: number | null
  saving: number
  startDeclineAmount: number
  remainingDeclineAmount: number
  savingNonPlus: number | null
  finalPageDisclaimer: string | null
  allowanceAmount: number | null

  constructor (json: any, disclaimers: any, allowanceAmount: number) {
    this.packageNumber = json.packageNumber
    this.packageName = json.packageName
    this.totalCharge = json.totalCharge
    this.totalMoop = json.totalMoop
    this.totalMoopNonPlus = (typeof (json.totalMoopNonPlus) === 'number') ? json.totalMoopNonPlus : null
    this.saving = json.saving
    this.startDeclineAmount = json.startDeclineAmount
    this.remainingDeclineAmount = json.remainingDeclineAmount
    this.savingNonPlus = (typeof (json.savingNonPlus) === 'number') ? json.savingNonPlus : null
    this.finalPageDisclaimer = this.getFinalPageDisclaimerAvailable(disclaimers)
    this.allowanceAmount = allowanceAmount
  }

  private getFinalPageDisclaimerAvailable (disclaimers: any) {
    if (disclaimers !== null) {
      const orderOneDisclaimer = disclaimers.filter((d: { order: number | string, value: string}) => d.order === 1 || d.order === 3)
      return orderOneDisclaimer.length ? orderOneDisclaimer[0].value : null
    }
    return null
  }

  public static of (json: any, disclaimers: any = null, allowanceAmount: number = 0): ServicePackageResponse {
    return new ServicePackageResponse(json, disclaimers, allowanceAmount)
  }
}
